// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

// === Firebase Config (DAT-GPT Project) ===
const firebaseConfig = {
  apiKey: "AIzaSyA90p-wVwKtLIYhcQ562lpqCEeecHZ4Nw8",
  authDomain: "dat-gpt.firebaseapp.com",
  projectId: "dat-gpt",
  storageBucket: "dat-gpt.appspot.com",
  messagingSenderId: "1082872055498",
  appId: "1:1082872055498:web:a50900f6038807f6ec9633",
  measurementId: "G-8Z0WR6CYYN",
};

// === Initialize Firebase App ===
const app = initializeApp(firebaseConfig);
console.log("📡 Firebase app initialized:", {
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
});

// === Auth ===
export const auth = getAuth(app);

/**
 * Send password reset email using Firebase's hosted reset flow.
 * Most robust: no custom actionCodeSettings (no routing to your app required).
 */
export async function sendPasswordReset(email) {
  return sendPasswordResetEmail(auth, email);
}

// also export the raw function if you need custom flows elsewhere
export { sendPasswordResetEmail };

// === Analytics (top-level opportunistic init; safe if unsupported) ===
let analyticsInstance = null;
let analyticsInitPromise = null; // collapses concurrent calls

// Fire-and-forget attempt (doesn't throw in unsupported envs)
isSupported()
  .then((supported) => {
    if (!supported) {
      console.warn("❌ Firebase Analytics not supported in this browser.");
      return;
    }
    analyticsInstance = getAnalytics(app);
    console.log("✅ Firebase Analytics initialized (top-level)");
  })
  .catch((err) => {
    console.error("❌ Analytics support check failed:", err);
  });

/**
 * Get (or lazily initialize) the Analytics singleton.
 * - SSR safe (returns null on server)
 * - Collapses concurrent inits
 * - Retries on subsequent calls if a previous attempt failed
 */
export async function getAnalyticsInstance() {
  if (typeof window === "undefined") return null; // SSR guard
  if (analyticsInstance) return analyticsInstance;
  if (analyticsInitPromise) return analyticsInitPromise;

  analyticsInitPromise = (async () => {
    try {
      const supported = await isSupported().catch(() => false);
      if (!supported) {
        console.warn(
          "❌ Firebase Analytics not supported in this environment."
        );
        return null;
      }
      const inst = getAnalytics(app);
      analyticsInstance = inst;
      console.log("✅ Firebase Analytics initialized (lazy)");
      return inst;
    } catch (err) {
      console.error("❌ Error initializing Firebase Analytics:", err);
      return null;
    } finally {
      // allow future retries
      analyticsInitPromise = null;
    }
  })();

  return analyticsInitPromise;
}

export default app;
